import { FieldPolicy } from '@apollo/client/core';
import { DateTime } from 'luxon';

export const dateTimeTypePolicy: FieldPolicy<DateTime, string> = {
  merge: (_, incoming) => {
    return DateTime.fromISO(incoming, { setZone: true });
  },
};
